/**
 *
 * my followup Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Badge,
  Spinner,
  Table,
} from "reactstrap"
import * as auditAction from "../../store/c2FsZXNG/actions"
import { Link, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as myFollowupAction from "../../store/TXlGb2xsb3d1cA/actions"
import { isEmpty } from "lodash"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import { ToastContainer, toast } from "react-toastify"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import * as manageFollowupAction from "../../store/bWFuYWdlRm9sbG93/actions"
import api from "helpers/Api"

const MyFollowup = (props) => {
  const title = "My Followup"

  const { dispatch, searchBtnStyle } = props

  const specificDispatch = useDispatch()
  const [applyFilter, setApplyFilter] = useState(false)
  // const { SearchBar } = Search

  useEffect(() => {
    dispatch(myFollowupAction.loadRecordsMetaData())
    dispatch(
      myFollowupAction.loadMyFollowupList({
        page: 1,
        limit: 50,
        // fromDate: today,
        // toDate: today,
      })
    )
    setApplyFilter(false)

  }, [])




  const permissionUpdate = useSelector(
    (specificstate) => specificstate.myFollowup
  )
  const { myFollowupMetaData = {}, followup_details = [] } = permissionUpdate
  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  //Date format
  const dateSetting = !isEmpty(responseLogin)
    ? responseLogin.setting.dateFormate.toUpperCase()
    : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Access for download

  const loginAccess = !isEmpty(user) && user ? user : []

  const followupMenu =
    !isEmpty(loginAccess) && loginAccess.menu
      ? loginAccess.menu.filter(
        (menu) => menu.menuId._id === "623854fcf73a35e88bb021b6"
      )
      : []
  //
  //"623854fcf73a35e88bb021b6"  "623854fcf73a35e88bb021b6"
  const menuId =
    !isEmpty(followupMenu) && followupMenu.length > 0
      ? followupMenu.map((menu) => menu.menuId.menuSubHeader)
      : []

  const accessId =
    !isEmpty(menuId) && menuId.length > 0
      ? menuId[0].filter(
        (data) =>
          data._id === "63a03478f63c05150fd0824f"
      )
      : []

  const accessDetails =
    !isEmpty(accessId) && accessId.length > 0
      ? accessId.map((menu) => menu.access)
      : []

  const downloadAccess =
    !isEmpty(accessDetails) && accessDetails.length > 0
      ? accessDetails[0].filter(
        (data) => data.accessName == "Download" && data.accessName != undefined &&
          data._id === "61bc3079e2e60e9919697604"
      )
      : []

  //_id
  const downloadAccessId =
    !isEmpty(downloadAccess) && downloadAccess.length > 0
      ? downloadAccess[0]._id
      : []

  const [btnLoader, setBtnLoader] = useState(false)
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: [],
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [followupMode, setFollowupMode] = useState([])
  const [priorityCode, setPriorityCode] = useState([])
  const [clientStatus, setClientStatus] = useState([])
  const [isPremium, setIsPremium] = useState("")
  const [venueName, setVenueName] = useState([])

  const statusList = [
    {
      label: "Is Premium",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setIsPremium(value)
      // setAuditChecked(true)
    } else {
      setIsPremium(false)
    }

  }
  //dropdown options api
  const branchOptions =
    !isEmpty(myFollowupMetaData) &&
    myFollowupMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )


  //checking
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const priority =
    !isEmpty(priorityCode) && priorityCode.map((priority) => priority.value)



  const handleChange = async (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [leadStatus, setLeadStatus] = useState([])

  const leadStatusValue = !isEmpty(leadStatus) ? leadStatus.map(m => m.value) : ""
  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchFollowup = followupMode && followupMode ? followupMode.value : ""
    var searchPriority = priorityCode && priorityCode ? priority : ""
    var searchClientStatus =
      clientStatus && clientStatus ? clientStatus.value : ""
    var searchLeadStatus =
      leadStatus && leadStatus ? leadStatusValue : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchVenue = venueName && venueName ? venueName.value : ""
    var searchPremium = isPremium == true ? true : false
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchVenue) {
      searchvalue.venueId = searchVenue
    }
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchFollowup) {
      searchvalue.mode = searchFollowup
    }
    if (searchClientStatus) {
      searchvalue.clientStatus = searchClientStatus
    }
    if (searchLeadStatus) {
      searchvalue.leadSubStatus = searchLeadStatus
    }
    if (searchPriority) {
      searchvalue.priorityId = searchPriority
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }

    setPageLoad(!pageLoad)

    specificDispatch(myFollowupAction.loadMyFollowupList(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setApplyFilter(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const seasonDates = !isEmpty(myFollowupMetaData) && myFollowupMetaData.seasonOptions.map(m => m.label)
  const seasonDateFlat = !isEmpty(seasonDates) && seasonDates.flatMap(m => m)
  const seasonDateValue = !isEmpty(seasonDateFlat) && seasonDateFlat.map(m => moment(m).format(dateFormate))
  const seasonCompanys = !isEmpty(myFollowupMetaData) && myFollowupMetaData.seasonOptions.map(m => m.companyId)
  const companySeasonFlat = !isEmpty(seasonCompanys) && seasonCompanys.flatMap(m => m)
  const companySeasonId = !isEmpty(companySeasonFlat) &&
    companySeasonFlat.filter((item, index) => companySeasonFlat.indexOf(item) === index)
  const today = moment().format("YYYY-MM-DD")
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setLeadStatus([])
    setBranches([])
    setFollowupMode([])
    setPriorityCode([])
    setClientStatus([])
    setVenueName([])
    setIsPremium(false)
    setFollowupData({
      fromDate: "",
      toDate: "",
    })
    specificDispatch(
      myFollowupAction.loadMyFollowupList({
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
  }
  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setFollowupData({
          ...followupData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])
  // const [approvedData, setApprovedData] = useState("")
  const [pyramidModal, setPyramidModal] = useState(false)
  const [salesPyramidDetails, setSalesPyramidDetails] = useState()
  let slNo = 0
  const followupDataTable = !isEmpty(followup_details)
    ? followup_details.data.map((followupData, index) => {
      slNo = slNo + 1

      var followupDate = !isEmpty(followupData.followupDate)
        ? moment(followupData.followupDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      var leadDate = !isEmpty(followupData.leadDate)
        ? moment(followupData.leadDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      // aging and reassign difference
      const currentDay = moment().startOf("day")
      const createdDate = followupData.leadDate
        ? moment.utc(followupData.leadDate).startOf("day")
        : ""
      const assignedDate = followupData.leadAssignDate
        ? moment.utc(followupData.leadAssignDate).startOf("day")
        : ""

      const createdDifference =
        currentDay && !isEmpty(createdDate)
          ? currentDay.isValid() && createdDate.isValid()
            ? Math.ceil(currentDay.diff(createdDate, "days", true))
            : ""
          : ""
      const assignDifference =
        currentDay && !isEmpty(assignedDate)
          ? currentDay.isValid() && assignedDate.isValid()
            ? Math.ceil(currentDay.diff(assignedDate, "days", true))
            : ""
          : ""
      const dayDiffValue = `${createdDifference}/${assignDifference} days`
      const isBold = createdDifference > 60 ? true : false
      const eventDate = followupData.eventDate ? moment(followupData.eventDate).startOf('day') : ""
      const followupDateValue = followupData.followupDate ? moment(followupData.followupDate).startOf('day') : ""
      const today = moment().startOf('day')
      const eventDateValue = eventDate ? eventDate.diff(today, 'days') : ""

      const followupCount = followupDateValue ? followupDateValue.diff(today, 'days') : ""
      const eventFollowup = eventDateValue && followupCount ?
        `${eventDateValue}/${followupCount}` : "--"
      const eventDateVal = followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : ""
      const isSeason = !isEmpty(seasonDateValue) && !isEmpty(companySeasonId) &&
        seasonDateValue.some((m) => m === eventDateVal)
        && companySeasonId.some((m) => m === followupData.companyId)
      return {
        _id: followupData._id,
        leadId: followupData.leadId,
        sNo: slNo,
        rowData: followupData,
        clientName: followupData.clientName,
        attachments: followupData.attachments,
        venueName: followupData.venueName ? followupData.venueName : "--",
        venueLocation: followupData.venueLocation
          ? followupData.venueLocation
          : "--",
        isPremium: followupData.isPremium,
        leadAssignArray: followupData.leadAssignArray,
        clientNo: followupData.clientNo,
        leadNo: followupData.leadNo,
        branchId: followupData.branchId,
        branchName: followupData.branchName,
        phoneNo: followupData.contact,
        companyId: followupData.companyId,
        priorityStatusName: followupData.priorityStatusName,
        session: followupData.session,
        followupDate: followupDate,
        salesUrge: followupData.salesUrge,
        followupStatus: followupData.followupStatus,
        processStatus: followupData.processStatusName,
        clientStatus: followupData.clientStatus,
        actualValue: followupData.actualAmount
          ? followupData.actualAmount
          : "--",
        discount: followupData.discount ? followupData.discount : "--",
        discountPercentage: followupData.discountPercentage
          ? Math.round(followupData.discountPercentage)
          : "--",
        currentFollowupDate: followupData.currentFollowupDate ? moment(followupData.currentFollowupDate).format(dateFormate) : "--",
        totalValue: followupData.totalAmount
          ? followupData.totalAmount
          : "--",
        budget: followupData.budget,
        strategyRemark: followupData.strategyRemark,
        modeName: followupData.modeName === "OFFICE VISIT" ? "YES" : "NO",
        followupMode: followupData.modeName,
        visitDateTime:
          followupData.modeName === "OFFICE VISIT"
            ? moment(followupData.visitDateTime).format("DD-MM-YYYY hh:mm A")
            : "---",
        companyName: followupData.companyName,
        leadSourceName: followupData.leadSourceName,
        leadDate: leadDate,
        leadServiceName: followupData.leadServiceName,
        fromTime: followupData.fromTime,
        toTime: followupData.toTime,
        agingDate: dayDiffValue,
        key: index,
        eventDate: followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : "--",
        followupCount: followupData.followupCount,
        clientVisit: followupData.clientVisitCount,
        eventFollowupCount: eventFollowup,
        isGreenFlag: followupData.isGreenFlag,
        isSeason: isSeason,
        salesPyramid: followupData.salesPyramid ? followupData.salesPyramid : "--",
        leadSubStatus: followupData.leadSubStatus ? followupData.leadSubStatus : "--",
        leadSource: followupData.leadSourceName ? followupData.leadSourceName : "--",
        leadService: followupData.leadServiceName ? followupData.leadServiceName : "--",
        eventServices: followupData.eventServices ? followupData.eventServices : "--",
        crossPromotion: followupData.crossPromotion ? followupData.crossPromotion : "--",
        greenFlagremarks: followupData.greenFlagremarks ? followupData.greenFlagremarks : "--",
        clientAppearanceRating: followupData.clientAppearanceRating ? `${followupData.clientAppearanceRating}  Ratings` : "--",
        salesPyramidHistory: followupData.salesPyramidHistory ? followupData.salesPyramidHistory : [],
        isBold: isBold,
        zgClient: !isEmpty(followupData.zgPlusClient) ? followupData.zgPlusClient.map(m => m).join(",") : "--",
        averageFollowup: followupData.averageFollowup ? followupData.averageFollowup : "--",
        goodLookingClient:followupData.goodLookingClient,
        highEndClient:followupData.highEndClient
      }

    })
    : []
  const [agingModal, setAgingModal] = useState(false)
  //aging assigned api
  const agingAssigned = (row) => {
    setAgingModal(true)
    const assignData = {
      leadId: row.leadId,
    }
    setTimeout(() => {
      dispatch(manageFollowupAction.loadAssigned(assignData))
    }, 500)
  }
  const agingUpdate = useSelector(
    (specificstate) => specificstate.manageFollowup
  )
  const { assign_details = [] } = agingUpdate
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const handleFollowupHistoryModal = () => {
    setFollowupHistoryModal(false)
  }
  const handleFollowupSubmit = (data) => {
    const payload = {
      leadId: data
    }
    setFollowupHistoryModal(true)
    setTimeout(() => {
      dispatch(auditAction.loadFollowupHistory(payload))
    }, 500)
  }


  const salesFollowupUpdate = useSelector(
    (specificstate) => specificstate.salesfollowup
  )
  const { followup_history = [] } = salesFollowupUpdate

  //pagination table data columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <Link
            to={{
              pathname: `/client-details/${row.leadId}`,
              state: { leadClientId: row.rowData, mode: "SALES" },
            }}
            style={{ textTransform: "uppercase" }}
          >
            {row.leadNo}
          </Link>
        )
      },
      style: (cell, row) => ({
        textTransform: "uppercase",
        color: "#e40d8c",
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "goodLookingClient",
      text: "Good Looking Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {   
         return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#FFD700",
                     backgroundColor: "#BF55EC"
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "highEndClient",
      text: "High End Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#BF55EC",
                      backgroundColor: "#FFD700"
                 
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      hidden: false,
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientAppearanceRating",
      text: "Client Appearance Rating",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "230px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "followupDate",
      text: "Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "session",
      text: "Session",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "100px",
      },
    },

    {
      dataField: "venueLocation",
      text: "Venue Location",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "venueName",
      text: "Venue Name",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "followupCount",
      text: "Followup Count",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "averageFollowup",
      text: "Average Followup",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "clientVisit",
      text: "Client Visit",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "135px",
      },
      hidden: false,
    },
    {
      dataField: "eventFollowupCount",
      text: "Event Date / Next Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "265px",
      },
    },
    {
      dataField: "isPremium",
      text: "Premium",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isPremium === "true" ? "success" : "danger"}
            style={{ padding: "8px 14px", fontSize: "12px" }}
          >
            {" "}
            {row.isPremium == "true" ? "Yes" : "No"}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "actualValue",
      text: "Actual Value",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "discount",
      text: "Discount",
      hidden: false,
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "discountPercentage",
      text: "Discount Percentage",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "budget",
      text: "Total Value / Budget",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "200px",
      },
    },

    {
      dataField: "processStatus",
      text: "Process Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followupStatus",
      text: "Followup Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {

        return (
          <Badge className="font-size-12 badge rounded-pill bg-danger badge-soft-danger">
            {row.followupStatus}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "clientStatus",
      text: "Client Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "138px",
      },
    },

    {
      dataField: "modeName",
      text: "Office Visit",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "visitDateTime",
      text: "Office Visit Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "155px",
      },
    },

    {
      dataField: "followupMode",
      text: "Follow Up Mode",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "phoneNo",
      text: "Mobile",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "strategyRemark",
      text: "Stratergy Remark",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "priorityStatusName",
      text: "Client Priority",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "agingDate",
      text: "Aging/Re-assigning",
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row">
            {row.agingDate}
            <div
              className="mx-2"
              onClick={() => {
                agingAssigned(row)
              }}
            >
              Aging
              <i
                className="mx-2 fas fa-eye"
                style={{ color: "#50a5f1", fontSize: "13px" }}
              ></i>
            </div>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      hidden: false,
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadSubStatus",
      text: "Lead Sub Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesPyramid",
      text: "Pyramid Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventServices",
      text: "Event Service",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "crossPromotion",
      text: "Cross Promotion",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadService",
      text: "Lead Service",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadSource",
      text: "Lead Source",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "currentFollowupDate",
      text: "Current Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "195px",
      },
    },
    {
      dataField: "followupHistory",
      text: "Followup History",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              {row.currentFollowupCount ? <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {row.followupCount}
                </span>
              </div> : "--"}

            </Col>
            <Col md="4" lg="4" sm="4">
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {

                  handleFollowupSubmit(row.leadId)
                }}
              ></i>
            </Col>
          </Row>

        )
      },
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "zgClient",
      text: "ZG + 1 Clients",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",

      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salePyramid",
      text: "Sale Pyramid History",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div
            className="ms-auto ml-2"
            onClick={() => {
              setSalesPyramidDetails(row.salesPyramidHistory)
              setPyramidModal(true)
            }}
          >
            <i
              className="fas fa-eye"
              style={{ color: "#50a5f1", fontSize: "15px" }}
            ></i>
          </div>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "greenFlagremarks",
      text: "Green Flag Remarks",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "185px",
      },
    },

  ]


  const clientStatusOptions = [
    {
      label: "VIP",
      value: "vip",
    },
    {
      label: "VVIP",
      value: "vvip",
    },
  ]
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }
  //Pagination Component
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  const handleClick = (e) => {
    // props.onSearch(input.value)

    setSearchFilter(true)
    e.preventDefault()
    specificDispatch(
      myFollowupAction.loadMyFollowupList({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const [downloadLoading, setDownloadLoading] = useState(false)
  const exportToCsv = () => {
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(priorityCode) ||
      !isEmpty(followupMode) ||
      !isEmpty(clientStatus) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchFollowup =
        followupMode && followupMode ? followupMode.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchClientStatus =
        clientStatus && clientStatus ? clientStatus.value : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchLeadStatus =
        leadStatus && leadStatus ? leadStatusValue : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""
      var searchVenue = venueName && venueName ? venueName.value : ""
      var searchPremium = isPremium
      var searchvalue = {}
      // searchvalue.page = pageChange ? pageCount : 1
      // searchvalue.limit = 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchFollowup) {
        searchvalue.mode = searchFollowup
      }
      if (searchVenue) {
        searchvalue.venueId = searchVenue
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchClientStatus) {
        searchvalue.clientStatus = searchClientStatus
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchLeadStatus) {
        searchvalue.leadSubStatus = searchLeadStatus
      }
      // let slNo = 0
      setPageLoad(!pageLoad)

      setDownloadLoading(true)
      api
        .post(`/get_my_future_followup_list_excel_export`, searchvalue)
        .then((response) => {
          const followupExportDataTable = !isEmpty(response.data.data)
            ? response.data.data.map((followupData, index) => {
              // serialNo = serialNo + 1

              var followupDate = !isEmpty(followupData.followupDate)
                ? moment(followupData.followupDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(`${dateFormate} hh:mm A`)
                : []
              var leadDate = !isEmpty(followupData.leadDate)
                ? moment(followupData.leadDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(`${dateFormate} hh:mm A`)
                : []
              const venueNameValue = !isEmpty(followupData.venueName)
                ? JSON.stringify(followupData.venueName).replace(/","/g, "\n")
                : "--"

              const venueLocation = followupData.venueLocation
                ? followupData.venueLocation
                : ""
              const venueLocationValue = !isEmpty(venueLocation)
                ? JSON.stringify(venueLocation).replace(/","/g, "\n")
                : "--"
              const strategyRemark = !isEmpty(followupData.strategyRemark)
                ? followupData.strategyRemark.replace(/[\r\n,.]/gm, "")
                : "--"
              const isPremium =
                followupData.isPremium === "true" ? "Yes" : "No"
              // aging and reassign difference
              const currentDay = moment().startOf("day")
              const createdDate = moment
                .utc(followupData.leadDate)
                .startOf("day")
              const assignedDate = moment
                .utc(followupData.leadAssignDate)
                .startOf("day")

              const createdDifference =
                currentDay && createdDate
                  ? currentDay.isValid() && createdDate.isValid()
                    ? Math.ceil(currentDay.diff(createdDate, "days", true))
                    : "--"
                  : "--"
              const assignDifference =
                currentDay && assignedDate
                  ? currentDay.isValid() && assignedDate.isValid()
                    ? Math.ceil(currentDay.diff(assignedDate, "days", true))
                    : "--"
                  : "--"
              const dayDiffValue = `${createdDifference}/${assignDifference} days`
              const eventDate = followupData.eventDate ? moment(followupData.eventDate).startOf('day') : ""
              const followupDateValue = followupData.followupDate ? moment(followupData.followupDate).startOf('day') : ""
              const today = moment().startOf('day')
              const eventDateValue = eventDate ? eventDate.diff(today, 'days') : ""

              const followupCount = followupDateValue ? followupDateValue.diff(today, 'days') : ""
              const eventFollowup = eventDateValue && followupCount ?
                `="${eventDateValue}/${followupCount}"` : "--"
              const zgClient = !isEmpty(followupData.zgPlusClient) ? followupData.zgPlusClient.map(m => m).join(",") : "--"
              const zgClientValue =
                !isEmpty(zgClient) && zgClient != ","
                  ? JSON.stringify(zgClient).replace(/","/g, "\n")
                  : "--"
              return {
                _id: followupData.leadId,
                sNo: index + 1,
                clientName: followupData.clientName,
                attachments: followupData.attachments,
                clientNo: followupData.clientNo
                  ? followupData.clientNo
                  : "--",
                branchId: followupData.branchId,
                branchName: followupData.branchName
                  ? followupData.branchName
                  : "--",
                phoneNo: followupData.contact ? followupData.contact : "--",
                leadNo: followupData.leadNo ? followupData.leadNo : "--",
                companyId: followupData.companyId,
                clientPriority: followupData.priorityStatusName
                  ? followupData.priorityStatusName
                  : "--",
                session: followupData.session ? followupData.session : "--",
                venueName: venueNameValue,
                venueLocation: venueLocationValue,
                isPremium: isPremium,
                followupDate: followupDate,
                salesUrge: followupData.salesUrge
                  ? followupData.salesUrge
                  : "--",
                leadAssign: followupData.leadAssign,
                budget: followupData.budget,
                actualValue: followupData.actualAmount
                  ? followupData.actualAmount
                  : "--",
                discount: followupData.discount
                  ? followupData.discount
                  : "--",
                discountPercentage: followupData.discountPercentage
                  ? Math.round(followupData.discountPercentage)
                  : "--",
                totalValue: followupData.totalAmount
                  ? followupData.totalAmount
                  : "--",
                followupStatus: followupData.followupStatus
                  ? followupData.followupStatus
                  : "--",
                processStatus: followupData.processStatusName
                  ? followupData.processStatusName
                  : "--",
                clientStatus: followupData.clientStatus
                  ? followupData.clientStatus
                  : "--",
                strategyRemark: strategyRemark,
                modeName:
                  followupData.modeName === "OFFICE VISIT" ? "YES" : "NO",
                followupMode: followupData.modeName,
                visitDateTime:
                  followupData.modeName === "OFFICE VISIT"
                    ? moment(followupData.visitDateTime).format(
                      "DD-MM-YYYY hh:mm A"
                    )
                    : "---",
                companyName: followupData.companyName
                  ? followupData.companyName
                  : "--",
                leadSourceName: followupData.leadSourceName
                  ? followupData.leadSourceName
                  : "--",
                leadDate: leadDate,
                leadServiceName: followupData.leadServiceName
                  ? followupData.leadServiceName
                  : "--",
                fromTime: followupData.fromTime,
                toTime: followupData.toTime,
                agingDate: dayDiffValue,
                key: index,
                salesPyramid: followupData.salesPyramid ? followupData.salesPyramid : "--",
                leadSubStatus: followupData.leadSubStatus ? followupData.leadSubStatus : "--",
                leadSource: followupData.leadSourceName ? followupData.leadSourceName : "--",
                leadService: followupData.leadServiceName ? followupData.leadServiceName : "--",
                eventServices: followupData.eventServices ? followupData.eventServices : "--",
                crossPromotion: followupData.crossPromotion ? followupData.crossPromotion : "--",
                eventFollowupCount: eventFollowup,
                eventDate: followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : "--",
                followupCount: followupData.followupCount ? followupData.followupCount : "--",
                clientVisit: followupData.clientVisitCount,
                zgClient: zgClientValue,
                averageFollowup: followupData.averageFollowup ? followupData.averageFollowup : "--",
                currentFollowupDate: followupData.currentFollowupDate ? moment(followupData.currentFollowupDate).format(dateFormate) : "--",
                greenFlagremarks: followupData.greenFlagremarks ? followupData.greenFlagremarks : "--",
                clientAppearanceRating: followupData.clientAppearanceRating ? `${followupData.clientAppearanceRating}  Ratings` : "--",
                goodLookingClient:followupData.goodLookingClient == true ? "YES" : "NO",
                highEndClient:followupData.highEndClient == true ? "YES" : "NO",
              }
            })
            : []
          setTimeout(() => {
            let headerData = [
              "SNo,Lead No,Good Looking Client,High End Client, Client No, Client Appearance Rating,Company Name, Branch Name, Followup Date,Session,venueLocation, Venue Name, Event Date, Followup Count,Average Followup,Client Visit,Event Date / Next Followup Date,Premium,Sales Urge, Actual Value,Discount, Discount Percentage,Total Value / Budget,Process Status, Followup Status,Client Status, Mode Name, Visit DateTime,Followup Mode, Client Name,PhoneNo, Strategy Remark, Client Priority,Current Followup Date,Aging/Re-assigning,Lead Date,Lead Sub Status,Pyamid Status,Event Services,Cross Promotion,Lead Service, Lead Source,ZG + 1 Clients,Green Flag Remarks",
            ]


            let usersCsv = !isEmpty(followupExportDataTable)
              ? followupExportDataTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  goodLookingClient,
                  highEndClient,
                  clientNo,
                  clientAppearanceRating,
                  companyName,
                  branchName,
                  followupDate,
                  session,
                  venueLocation,
                  venueName,
                  eventDate,
                  followupCount,
                  averageFollowup,
                  clientVisit,
                  eventFollowupCount,
                  isPremium,
                  salesUrge,
                  actualValue,
                  discount,
                  discountPercentage,
                  budget,
                  processStatus,
                  followupStatus,
                  clientStatus,
                  modeName,
                  visitDateTime,
                  followupMode,
                  clientName,
                  // leadAssign,
                  phoneNo,
                  strategyRemark,
                  clientPriority,
                  currentFollowupDate,
                  agingDate,
                  leadDate,
                  leadSubStatus,
                  salesPyramid,
                  eventServices,
                  crossPromotion,
                  leadService,
                  leadSource,
                  zgClient,
                  greenFlagremarks
                } = user
                acc.push([
                  sNo,
                  leadNo,
                  goodLookingClient,
                  highEndClient,
                  clientNo,
                  clientAppearanceRating,
                  companyName,
                  branchName,
                  followupDate,
                  session,
                  venueLocation,
                  venueName,
                  eventDate,
                  followupCount,
                  averageFollowup,
                  clientVisit,
                  eventFollowupCount,
                  isPremium,
                  salesUrge,
                  actualValue,
                  discount,
                  discountPercentage,
                  budget,
                  processStatus,
                  followupStatus,
                  clientStatus,
                  modeName,
                  visitDateTime,
                  followupMode,
                  clientName,
                  // leadAssign,
                  phoneNo,
                  strategyRemark,
                  clientPriority,
                  currentFollowupDate,
                  agingDate,
                  leadDate,
                  leadSubStatus,
                  salesPyramid,
                  eventServices,
                  crossPromotion,
                  leadService,
                  leadSource,
                  zgClient,
                  greenFlagremarks
                ])

                return acc
              }, [])
              : false

            if (usersCsv === false) {
              downloadFile({
                data: [...headerData].join("\n"),
                fileName: "myFollowup.csv",
                fileType: "text/csv",
              })
            } else if (usersCsv !== false) {
              downloadFile({
                data: [...headerData, ...usersCsv].join("\n"),
                fileName: "myFollowup.csv",
                fileType: "text/csv",
              })
            }

            setDownloadLoading(false)
          }, 2500)
          return response.data
        })
        .catch((error) => {
          Promise.reject(error)
          setDownloadLoading(false)
        })
      // specificDispatch(
      //   manageFollowupAction.loadManageFollowupExportList(searchvalue)
      // )
    }
  }

  const RemotePagination = ({
    data,
    page,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">

                      </Col>

                      <Col md="8" style={{ marginBottom: "20px", marginTop: "-41px" }}>
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          {downloadAccessId === "61bc3079e2e60e9919697604" ? (<Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginRight: "10px",
                            }}
                          >
                            Download
                          </Button>) : ("")}
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                      </Col>
                      {/* ) : (
                        ""
                      )} */}
                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)

    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(priorityCode) ||
      !isEmpty(followupMode) ||
      !isEmpty(clientStatus) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate) ||
      !isEmpty(leadStatus)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchVenue = venueName && venueName ? venueName.value : ""
      var searchPremium = isPremium
      var searchFollowup =
        followupMode && followupMode ? followupMode.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchClientStatus =
        clientStatus && clientStatus ? clientStatus.value : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""
      var searchLeadStatus =
        leadStatus && leadStatus ? leadStatusValue : ""
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchFollowup) {
        searchvalue.mode = searchFollowup
      }
      if (searchVenue) {
        searchvalue.venueId = searchVenue
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchClientStatus) {
        searchvalue.clientStatus = searchClientStatus
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchLeadStatus) {
        searchvalue.leadSubStatus = searchLeadStatus
      }
      setPageLoad(!pageLoad)

      specificDispatch(myFollowupAction.loadMyFollowupList(searchvalue))
    } else {
      dispatch(
        myFollowupAction.loadMyFollowupList({
          page: page,
          limit: sizePerPage,
        })
      )
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    setState(() => ({
      page,
      data: followup_details,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content" id="my-followup">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            myFollowupMetaData
                              ? myFollowupMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Followup Mode"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="followupMode"
                          value={followupMode}
                          onChange={(e) => setFollowupMode(e)}
                          options={
                            myFollowupMetaData
                              ? myFollowupMetaData.followupModeOptions
                              : []
                          }
                          placeholder="Select Followup"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Priority"}
                          </Label>
                        </div>
                        <Select
                          name="priorityCode"
                          value={priorityCode}
                          onChange={(e) => setPriorityCode(e)}
                          isMulti
                          options={
                            myFollowupMetaData
                              ? myFollowupMetaData.priorityOptions
                              : []
                          }
                          placeholder="Select Priority"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={followupData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={followupData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Status"}
                          </Label>
                        </div>
                        <Select
                          name="clientStatus"
                          value={clientStatus}
                          onChange={(e) => setClientStatus(e)}
                          isMulti
                          options={clientStatusOptions}
                          placeholder="Select Priority"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Venue"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="venueName"
                          value={venueName}
                          // isMulti
                          onChange={(e) => setVenueName(e)}
                          options={
                            myFollowupMetaData
                              ? myFollowupMetaData.venueOptions
                              : []
                          }
                          placeholder="Select Venue"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Status"}
                          </Label>
                        </div>
                        <Select
                          isMulti
                          name="leadStatus"
                          value={leadStatus}
                          onChange={(e) => setLeadStatus(e)}
                          options={
                             myFollowupMetaData
                              ?  myFollowupMetaData.processStatusOptions
                              : []
                          }
                          placeholder="Select Lead Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-4">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isPremium"
                                  value={status.value}
                                  checked={isPremium === status.value}
                                  // className={status.value ? "audit-status-border" : ""}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <Button
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#2ca67a" : "",
                          }}
                          className="btn btn-success mx-2"
                        >
                          <i className="fas fa-search"></i>
                        </Button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={followupDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={followup_details.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {agingModal && (
                    <Modal size="xl" show={agingModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Aging
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales Agent Code</th>
                                <th>Sales Agent Name</th>
                                <th>Created Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(assign_details) &&
                                assign_details.length > 0 ? (
                                assign_details.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.assignedEmployeeCode}</td>
                                      <td>{data.assignedEmployeeName}</td>
                                      <td>
                                        {moment(data.createdAt).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr key={0}>
                                  <td className="text-align-center" colSpan={4}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setAgingModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {pyramidModal && (
                    <Modal size="xl" show={pyramidModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Sale Pyramid History
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales Pyramid Status</th>
                                <th>Created By Name</th>
                                <th>Created Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {salesPyramidDetails && !isEmpty(salesPyramidDetails) ?
                                salesPyramidDetails.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index}</td>
                                      <td>{data.salesPyramid ? data.salesPyramid : "--"}</td>
                                      <td>{data.salesPyramidOn ? moment(data.salesPyramidOn).format(dateFormate) : "--"}</td>
                                      <td>{data.salesPyramidByName ? data.salesPyramidByName : "--"}</td>
                                    </tr>
                                  )
                                })
                                : <tr key={0}>
                                  <td className="text-align-center" colSpan={4}>
                                    No Records Found...
                                  </td>
                                </tr>}

                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setPyramidModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {followupHistoryModal && (
                    <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <Col
                          xl="6"
                          lg="6"
                          md="6"
                          sm="6"
                          xs="6"
                          className="d-flex flex-row"
                        >
                          <span>Followup History</span>
                          {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
                        </Col>
                      </Modal.Header>
                      <Modal.Body>

                        <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                          <Table responsive>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th >Followup Status</th>
                                <th >Followup Date</th>
                                <th >Followup No</th>
                                <th >Followup Mode</th>
                                <th >Followup Remarks</th>
                                <th >Followup Attachment</th>
                                <th>Future Followup Date</th>
                                <th>Future Followup Mode</th>
                                {/* <th>Future Followup Remarks</th> */}
                                <th>Future Followup Strategy</th>
                                <th>Strategy Remark</th>
                              </tr>
                            </thead>
                            <tbody>
                              {followup_history && !isEmpty(followup_history) ?
                                followup_history.map((item, index) => {

                                  const attachment = !isEmpty(item.recordAttachment)
                                    ? item.recordAttachment[0]
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  const futureFollowupStrategyName = !isEmpty(item.futureFollowupStrategyName) ?
                                    item.futureFollowupStrategyName.map(m => m).join(",") : "--"


                                  const futureFollowupmodeName = !isEmpty(item.futureFollowupmodeName) ?
                                    item.futureFollowupmodeName.map(m => m).join(",") : "--"

                                  const followupStatusName = !isEmpty(item.followupStatusName) ?
                                    item.followupStatusName.map(m => m).join(",") : "--"
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{followupStatusName}</td>
                                      <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                                      <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                                      <td>{item.modeName ? item.modeName : "--"}</td>
                                      <td>{item.remarks ? item.remarks : "--"}</td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                          <div className="d-flex flex-row align-items-center">
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachment,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>

                                          </div>
                                        ) : (attachment &&
                                          attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>{item.futurefollowupDate ? moment(item.futurefollowupDate).format(dateFormate) : "--"}</td>
                                      <td>{futureFollowupmodeName}</td>
                                      {/* //   <td>{item.futureFollowupRemarks ? item.futureFollowupRemarks : "--"}</td> */}
                                      <td>{futureFollowupStrategyName}</td>
                                      <td>{item.strategyRemark ? item.strategyRemark : "--"}</td>
                                    </tr>)

                                }) :
                                <tr>
                                  <td className="text-align-center" colSpan={11}>
                                    No Records Found...
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </Table>
                        </Col>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="d-flex flex-row">
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleFollowupHistoryModal}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="secondary"
                            className="btn btn-success mx-2"
                            onClick={handleFollowupHistoryModal}
                          >
                            Submit
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

MyFollowup.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyFollowup)
)
